import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const handleLinkClick = async (linkType) => {
  const { logAnalyticsEvent } = await import('../../utils/analyticsUtils');
  logAnalyticsEvent('footer_link_click', {
    link_type: linkType
  });
};

const MusicFooter = () => {
  return (
    <footer className={styles.footerContainer}>
      <nav className={styles.footerNav} aria-label="Footer">
        <div className={styles.policyLinks}>
          <Link to="/privacyPolicy" style={{ padding: '18px', margin: '-18px' }} onClick={() => handleLinkClick('privacy_policy')}>Privacy Policy</Link>
          <Link to="/termsOfService" style={{ padding: '18px', margin: '-18px' }} onClick={() => handleLinkClick('terms_of_service')}>Terms of Service</Link>
        </div>


        {/* Hardcode transforms because each SVG is centered in its own frame with whitespace */}
        <div className={styles.socialLinks}>
          <a href="https://www.instagram.com/notesfromlaw" aria-label="Instagram" rel="noopener noreferrer" target="_blank" onClick={() => handleLinkClick('instagram')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--highlight)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className={`icon lucide lucide-instagram-icon lucide-instagram ${styles.socialIcon}`} aria-hidden="true"><rect width="20" height="20" x="2" y="2" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" x2="17.51" y1="6.5" y2="6.5" /></svg>
          </a>

          <Link to="/contact" aria-label="Contact" onClick={() => handleLinkClick('contact_form')}>
            <svg style={{ transform: 'translateY(1.2px)' }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--highlight)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className={`icon lucide lucide-mail-icon lucide-mail ${styles.socialIcon}`} aria-hidden="true"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" /><rect x="2" y="4" width="20" height="16" rx="2" /></svg>
          </Link>

          <a href="https://www.youtube.com/@notesfromlaw" aria-label="YouTube" rel="noopener noreferrer" target="_blank" onClick={() => handleLinkClick('youtube')}>
            <svg style={{ transform: 'translateY(2px)' }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--highlight)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className={`icon lucide lucide-youtube-icon lucide-youtube ${styles.socialIcon}`} aria-hidden="true"><path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" /><path d="m10 15 5-3-5-3z" /></svg>
          </a>
        </div>
      </nav>
    </footer>
  )
}

export default MusicFooter;